"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CurrencyInput',
    props: {
        id: null,
        value: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const inputActive = (0, vue_2.ref)(false);
        const displayValue = (0, vue_2.computed)({
            get() {
                if (inputActive.value) {
                    return props.value.toString();
                }
                return "$" + props.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            },
            set(modifiedValue) {
                let newValue = parseFloat(modifiedValue.replace(/[^\d.]/g, ""));
                if (isNaN(newValue)) {
                    newValue = 0;
                }
                emit("input", newValue);
            },
        });
        return { __sfc: true, props, emit, inputActive, displayValue };
    }
});
